import React, {
  createContext,
  PropsWithChildren,
  useContext,
  useMemo,
} from "react";

interface IUnmountProductTileContextValue {
  onUnmount: (productToken: string, impressionId: string) => void;
}

const UnmountProductTileContext =
  createContext<IUnmountProductTileContextValue>({ onUnmount: () => {} });

export const UnmountProductTileProvider: React.FC<
  PropsWithChildren<IUnmountProductTileContextValue>
> = ({ onUnmount, children }) => {
  const value = useMemo(() => {
    return {
      onUnmount,
    };
  }, [onUnmount]);

  return (
    <UnmountProductTileContext.Provider value={value}>
      {children}
    </UnmountProductTileContext.Provider>
  );
};

export const useUnmountProductTileContext =
  (): IUnmountProductTileContextValue => {
    return useContext(UnmountProductTileContext);
  };
